<template>
<div class="chapter">
<div class="inner_page">
<p><a id="pl-3-2"></a></p>
<p class="textstyle3">Editor: Lee M. Jonsson</p>
<p class="textstyle3">Technical Editor: Diana Roberts</p>
<p class="textstyle3">Copy Editor: Judith M. Moretz</p>
<p class="textstyle3">Illustrations: Gretchen Schwarzenbach, GNS Graphics, and John M. Cram</p>
<p class="textstyle3">Cover design: John M. Cram and Kathy Lee</p>
<p class="textstyle3">Book design: John M. Cram and Diane Pedersen</p>
<p class="textstyle3">Photography: Sharon Risedorph Photography, San Francisco, California;</p>
<p class="textstyle3">Cevin Brent Smith Photography, Raleigh, North Carolina; and</p>
<p class="textstyle3">Jim Egan Photography, Providence, Rhode Island</p>
<p class="textstyle3">Interior mill shots: Cotton Incorporated, Raleigh, North Carolina, Cranston</p>
<p class="textstyle3">Print Works Company, Webster, Massachusetts, and Pendleton Woolen Mills, Portland, Oregon</p>
<p class="textstyle3">Author photo: James Koch</p>
<p class="textstyle3">Photographs in Chapter 8, 9, 13, and all chapter openers by Sharon</p>
<p class="textstyle3">Risedorph. Photographs in Chapters 3 and 6 by Cevin Brent Smith unless</p>
<p class="textstyle3">otherwise noted. Photographs in Chapters 4 and 7 by Jim Egan unless</p>
<p class="textstyle3">otherwise noted. Photographs in Chapter 5 by Pendleton Woolen Mills.</p>
<p class="textstyle3">Photographs in Chapter 12 by Harriet Hargrave.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_copyrighttitle.vue?af9ece04